import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=cf20c802"
import script from "./image-viewer.vue?vue&type=script&lang=js"
export * from "./image-viewer.vue?vue&type=script&lang=js"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=cf20c802&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports